import { FC } from 'react';
import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import CreditHistoryPage from '../../../pages/Cards/CreditHistoryPage';
import CreditHistoryMobile from '../../../pages/Mobile/Cards/CreditHistoryMobile';

const CreditHistoryResponsive: FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <CreditHistoryMobile /> : <CreditHistoryPage />;
};

export default CreditHistoryResponsive;
